const invertedMessages = {
  Close: 'CloseLabel',
  Error: 'certs.error',
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
};

export default invertedMessages;
